import script from "./NameAndEmailBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NameAndEmailBlock.vue?vue&type=script&setup=true&lang=js"

import "./NameAndEmailBlock.vue?vue&type=style&index=0&id=3a2d22f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a2d22f6"]])

export default __exports__